import React, { useState } from 'react'
import MainLayout from '../Layouts/MainLayout'
import ContributorDetails from './contributorDetails'


function ContributorDetailsContainer() {
  return (
    <MainLayout navTitle={"Contributor Details"} navSubTitle={"Welcome to ImagesBazaar"}>
      <ContributorDetails/>
    </MainLayout>
  )
}

export default ContributorDetailsContainer